export default __webpack_public_path__ + "static/media/logo_partial.9848e447.png";